import React, { useMemo } from 'react';
import {
  RightContainer,
  TopWinnersContainer,
  userInfoStore,
  useTranslation,
} from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { LiveBetsWrapper } from '../liveBetsWrapper';
import { BetHistoryWrapper } from '../betHistoryWrapper';
import { CurrentAndTopWinnersItem } from '../lobbyAndTopWinnersItem';
import { globalTranslationKeys } from '../../../../enums';

const RightColumn = observer(() => {
  const { LiveBets, History, TopWinners } = globalTranslationKeys;

  const { currencyCode } = userInfoStore;

  const t = useTranslation();

  const rightContainerTabs = useMemo(
    () => [{ name: LiveBets }, { name: History, isBetHistory: true }, { name: TopWinners }],
    []
  );

  const rightContainerTabsContainers = useMemo(
    () => [
      <LiveBetsWrapper t={t} currencySymbol={currencyCode} />,
      <BetHistoryWrapper />,
      <TopWinnersContainer
        renderCurrentOrTopWinnerItem={(betData) => (
          <CurrentAndTopWinnersItem betData={betData} key={JSON.stringify(betData)} />
        )}
      />,
    ],
    []
  );

  return (
    <RightContainer
      hasFreeBets
      tabs={rightContainerTabs}
      onTabChange={() => {}}
      tabContainers={rightContainerTabsContainers}
      userImageSrc=''
      hasChat
    />
  );
});

export default RightColumn;
